/**
 * Single source of truth for client logos
 * Used by both InfiniteRollingLogos component and HTML preload injection
 * 
 * Logos are defined in logos.json for easy sharing between Node.js scripts
 * and React components
 */

import LOGOS_DATA from "./logos.json";

export const LOGOS = LOGOS_DATA;

export const LOGOS_PATH = "assets/Logos";

/**
 * Get logo image path
 * @param {string} name - Logo name
 * @param {boolean} tiny - Whether to get tiny version
 */
export const getLogoPath = (name, tiny = false) => {
  return `${LOGOS_PATH}/${name}${tiny ? "-tiny" : ""}.png`;
};

/**
 * Get all logo attributes for rendering
 */
export const getLogoAttributes = () => {
  return LOGOS.map((logo) => ({
    alt: logo.name,
    height: `${logo.scale * 0.7}%`,
    src: getLogoPath(logo.name),
    placeholder: getLogoPath(logo.name, true),
    key: logo.name,
  }));
};
